import {
  BuiltInTicketType,
  DynamicTicketTypeNotifyAssigneeMode,
} from '@main-application/management/pages/service-configuration/dynamic-tickets/components/add-ticket-type-dialog/add-ticket-type-dialog.component';

export enum TicketType {
  Other = 0,
  Turn = 1,
  Punch = 2,
  Inspection = 3,
  Resident = 4,
  Cost = 5,
}

export interface CreateDynamicTicketTypeModel {
  name: string;
  builtInType: BuiltInTicketType;
  notifyAssignee: DynamicTicketTypeNotifyAssigneeMode;
  notifyAssigneeOnCustom: number | null;
  remindAssigneeEveryNDays: number | null;
  remindAssigneeStopAfterNReminders: number | null;
}
